export const orangeStyle = {
  color: "var(--status-error)",
  borderColor: "var(--status-error)",
};
export const textFieldSX = {
  "&.MuiTextField-root": {
    ".MuiInputLabel-root": {
      opacity: 1,
      color: "var(--status-muted)",
      "&.Mui-focused": {
        color: "var(--status-muted)",
      },
    },
    "& .MuiInputBase-input": {
      color: "inherit",
    },
  },
};